import { createSelector } from 'reselect';
import { MESSAGING_TRUSTED } from '../../constants/Scopes';
import { getScopes } from './getScopes';
export const hasMessagingTrustedAccess = createSelector(getScopes, scopes => scopes.includes(MESSAGING_TRUSTED));